// 迷妹漫画 - Mock 数据

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line' },
  { slug: 'shounen', name: '少年热血', icon: 'ri-fire-line' },
  { slug: 'shoujo', name: '少女恋爱', icon: 'ri-heart-line' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line' },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-rocket-line' },
  { slug: 'horror', name: '悬疑恐怖', icon: 'ri-ghost-line' },
  { slug: 'scifi', name: '科幻未来', icon: 'ri-planet-line' },
  { slug: 'slice', name: '治愈日常', icon: 'ri-cup-line' },
  { slug: 'action', name: '动作格斗', icon: 'ri-boxing-line' },
  { slug: 'isekai', name: '异世界', icon: 'ri-door-open-line' },
];

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  chapters: number;
  updateTime: string;
  latestChapter: string;
}

export interface Chapter {
  id: number;
  comicId: number;
  title: string;
  number: number;
  updateTime: string;
  pages: number;
}

export const featuredComics: Comic[] = [
  {
    id: 1,
    title: '星辰变',
    author: '我吃西红柿',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20manhua%20cover%20style%20illustration%20of%20a%20young%20warrior%20with%20flowing%20hair%20standing%20on%20a%20mountain%20peak%20under%20a%20starry%20night%20sky%2C%20dramatic%20lighting%2C%20celestial%20elements%2C%20clean%20white%20background%2C%20anime%20art%20style%2C%20vibrant%20colors%2C%20high%20contrast%2C%20detailed%20character%20design&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '一部背景极大的奇幻修真小说，主角秦羽先天无法修炼内功，为了得到父亲重视，他毅然选择修炼最痛苦艰难的外功。',
    category: 'fantasy',
    tags: ['热血', '修仙', '奇幻', '少年'],
    status: '连载中',
    rating: 9.6,
    views: '1.2亿',
    chapters: 856,
    updateTime: '2026-08-04',
    latestChapter: '第856话 星辰大海'
  },
  {
    id: 2,
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20manhua%20cover%20featuring%20a%20mysterious%20young%20man%20with%20supernatural%20energy%20swirling%20around%20him%2C%20urban%20fantasy%20setting%2C%20traditional%20Chinese%20elements%20mixed%20with%20modern%20city%2C%20clean%20white%20background%2C%20anime%20art%20style%2C%20dramatic%20composition&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '随着父亲失踪，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。',
    category: 'action',
    tags: ['热血', '异能', '国漫', '动作'],
    status: '连载中',
    rating: 9.5,
    views: '9800万',
    chapters: 720,
    updateTime: '2026-08-03',
    latestChapter: '第720话 真相浮现'
  },
  {
    id: 3,
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20manhua%20cover%20with%20a%20fox%20spirit%20girl%20with%20long%20flowing%20hair%20and%20pink%20accents%2C%20cherry%20blossom%20petals%20floating%2C%20soft%20dreamy%20atmosphere%2C%20clean%20white%20background%2C%20anime%20art%20style%2C%20ethereal%20and%20romantic%20mood&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '世上有人有妖，妖会与人相恋，妖寿命千万年，人寿命有限，人死了妖还活着。',
    category: 'shoujo',
    tags: ['恋爱', '奇幻', '古风', '转世'],
    status: '已完结',
    rating: 9.7,
    views: '1.5亿',
    chapters: 504,
    updateTime: '2026-06-15',
    latestChapter: '第504话 终章'
  },
  {
    id: 4,
    title: '斗破苍穹',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20manhua%20cover%20showing%20a%20determined%20young%20man%20surrounded%20by%20flames%20and%20elemental%20energy%2C%20martial%20arts%20theme%2C%20ancient%20Chinese%20fantasy%20world%2C%20clean%20white%20background%2C%20anime%20art%20style%2C%20intense%20and%20powerful%20composition&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，种种打击接踵而至。',
    category: 'shounen',
    tags: ['热血', '修仙', '战斗', '升级'],
    status: '已完结',
    rating: 9.4,
    views: '2.1亿',
    chapters: 1624,
    updateTime: '2025-12-20',
    latestChapter: '第1624话 大结局'
  },
  {
    id: 5,
    title: '镇魂街',
    author: '许辰',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20manhua%20cover%20with%20a%20cool%20male%20protagonist%20holding%20a%20spirit%20weapon%2C%20ghostly%20guardian%20spirits%20behind%20him%2C%20ancient%20Chinese%20architecture%2C%20dark%20atmospheric%20lighting%2C%20clean%20white%20background%2C%20anime%20art%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '普通应届大学毕业生夏铃在求职之际，收到了一条奇怪的面试通知，误入了罗刹街。',
    category: 'action',
    tags: ['热血', '灵异', '战斗', '守护'],
    status: '连载中',
    rating: 9.3,
    views: '8500万',
    chapters: 420,
    updateTime: '2026-08-02',
    latestChapter: '第420话 新世界'
  }
];

export const latestUpdates: Comic[] = [
  {
    id: 6,
    title: '全职高手',
    author: '蝴蝶蓝',
    cover: 'https://readdy.ai/api/search-image?query=A%20gaming%20esports%20themed%20manhua%20cover%20with%20a%20cool%20male%20character%20holding%20a%20gaming%20controller%2C%20virtual%20game%20world%20elements%2C%20competitive%20atmosphere%2C%20clean%20white%20background%2C%20anime%20art%20style%2C%20modern%20and%20sleek&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐。',
    category: 'action',
    tags: ['电竞', '热血', '竞技', '逆袭'],
    status: '已完结',
    rating: 9.5,
    views: '7200万',
    chapters: 680,
    updateTime: '2026-08-04',
    latestChapter: '第680话 荣耀之巅'
  },
  {
    id: 7,
    title: '魔道祖师',
    author: '墨香铜臭',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20fantasy%20manhua%20cover%20with%20two%20elegant%20male%20cultivators%20in%20flowing%20robes%2C%20ancient%20Chinese%20setting%20with%20mountains%20and%20mist%2C%20magical%20elements%2C%20clean%20white%20background%2C%20anime%20art%20style%2C%20artistic%20and%20atmospheric&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '前世的魏无羡万人唾骂，声名狼藉。被情同手足的师弟带人端了老巢。',
    category: 'fantasy',
    tags: ['耽美', '修仙', '古风', '悬疑'],
    status: '已完结',
    rating: 9.6,
    views: '1.1亿',
    chapters: 256,
    updateTime: '2026-08-04',
    latestChapter: '番外篇 忘羡日常'
  },
  {
    id: 8,
    title: '海贼王',
    author: '尾田荣一郎',
    cover: 'https://readdy.ai/api/search-image?query=A%20classic%20pirate%20adventure%20manga%20style%20cover%20with%20a%20young%20pirate%20captain%20with%20a%20straw%20hat%2C%20ocean%20and%20ship%20background%2C%20treasure%20theme%2C%20clean%20white%20background%2C%20dynamic%20anime%20art%20style%2C%20adventurous%20spirit&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '拥有财富、名声、权力，这世界上的一切的男人——海贼王哥尔·D·罗杰，临刑前的一句话开启了「大海贼时代」。',
    category: 'shounen',
    tags: ['冒险', '热血', '友情', '长篇'],
    status: '连载中',
    rating: 9.8,
    views: '5.2亿',
    chapters: 1120,
    updateTime: '2026-08-04',
    latestChapter: '第1120话 新的航路'
  },
  {
    id: 9,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20demon%20slayer%20manga%20cover%20style%20with%20a%20young%20swordsman%20with%20a%20nichirin%20blade%2C%20traditional%20Japanese%20aesthetic%2C%20water%20breathing%20effects%2C%20clean%20white%20background%2C%20anime%20art%20style%2C%20intense%20and%20beautiful&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '大正时期，卖炭少年炭治郎一家惨遭鬼的杀害，唯一幸存的妹妹祢豆子却变成了鬼。',
    category: 'shounen',
    tags: ['热血', '战斗', '兄妹', '鬼怪'],
    status: '已完结',
    rating: 9.5,
    views: '3.8亿',
    chapters: 205,
    updateTime: '2026-08-04',
    latestChapter: '第205话 新生'
  },
  {
    id: 10,
    title: '间谍过家家',
    author: '远藤达哉',
    cover: 'https://readdy.ai/api/search-image?query=A%20fun%20spy%20family%20comedy%20manga%20cover%20with%20a%20family%20of%20three%20in%20matching%20outfits%2C%20spy%20theme%20elements%2C%20playful%20and%20warm%20atmosphere%2C%20clean%20white%20background%2C%20anime%20art%20style%2C%20colorful%20and%20charming&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '为了潜入名校，西国能力最强的间谍「黄昏」被下令组建家庭。但是他找到的「女儿」居然是读心超能力者，「妻子」是暗杀者？',
    category: 'comedy',
    tags: ['搞笑', '家庭', '间谍', '温馨'],
    status: '连载中',
    rating: 9.4,
    views: '2.4亿',
    chapters: 98,
    updateTime: '2026-08-04',
    latestChapter: '第98话 家庭旅行'
  },
  {
    id: 11,
    title: '咒术回战',
    author: '芥见下下',
    cover: 'https://readdy.ai/api/search-image?query=A%20supernatural%20battle%20manga%20cover%20with%20a%20spiky%20haired%20teenager%20surrounded%20by%20cursed%20energy%2C%20dark%20urban%20setting%2C%20intense%20action%20vibe%2C%20clean%20white%20background%2C%20anime%20art%20style%2C%20striking%20red%20and%20black%20colors&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '高中生虎杖悠仁的祖父在逝世前嘱咐他要尽可能帮助他人，并希望他在众人簇拥下死去。',
    category: 'horror',
    tags: ['战斗', '咒术', '热血', '黑暗'],
    status: '连载中',
    rating: 9.3,
    views: '2.8亿',
    chapters: 260,
    updateTime: '2026-08-04',
    latestChapter: '第260话 决战'
  },
  {
    id: 12,
    title: '排球少年',
    author: '古馆春一',
    cover: 'https://readdy.ai/api/search-image?query=A%20sports%20volleyball%20manga%20cover%20with%20an%20energetic%20short%20boy%20jumping%20to%20spike%20a%20volleyball%2C%20gymnasium%20setting%2C%20team%20spirit%2C%20clean%20white%20background%2C%20anime%20art%20style%2C%20dynamic%20and%20inspiring&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '小时候，日向翔阳从电视上看到排球比赛，乌野高中的小巨人在球场上的英姿让他备受震撼。',
    category: 'shounen',
    tags: ['运动', '热血', '青春', '团队'],
    status: '已完结',
    rating: 9.6,
    views: '1.6亿',
    chapters: 402,
    updateTime: '2026-08-04',
    latestChapter: '第402话 终章'
  }
];

export const rankingComics: Comic[] = [
  { ...featuredComics[4], rating: 9.8, views: '5.2亿' },
  { ...featuredComics[2], rating: 9.7, views: '1.5亿' },
  { ...featuredComics[0], rating: 9.6, views: '1.2亿' },
  { ...latestUpdates[6], rating: 9.6, views: '1.6亿' },
  { ...latestUpdates[1], rating: 9.6, views: '1.1亿' },
  { ...featuredComics[1], rating: 9.5, views: '9800万' },
  { ...latestUpdates[0], rating: 9.5, views: '7200万' },
  { ...latestUpdates[3], rating: 9.5, views: '3.8亿' },
  { ...featuredComics[3], rating: 9.4, views: '2.1亿' },
  { ...latestUpdates[4], rating: 9.4, views: '2.4亿' },
];

export function getComicsByCategory(slug: string): Comic[] {
  if (slug === 'all') return [...featuredComics, ...latestUpdates];
  return [...featuredComics, ...latestUpdates].filter(c => c.category === slug);
}

export function getComicById(id: number): Comic | undefined {
  return [...featuredComics, ...latestUpdates].find(c => c.id === id);
}

export function getChaptersByComicId(comicId: number): Chapter[] {
  const comic = getComicById(comicId);
  if (!comic) return [];
  return Array.from({ length: Math.min(comic.chapters, 50) }, (_, i) => ({
    id: i + 1,
    comicId,
    title: `第${comic.chapters - i}话`,
    number: comic.chapters - i,
    updateTime: i < 3 ? '2026-08-04' : `2026-0${7 - Math.floor(i / 10)}-${String(30 - i).padStart(2, '0')}`,
    pages: Math.floor(Math.random() * 30) + 15,
  }));
}

export const slideBanners = [
  {
    id: 1,
    comicId: 4,
    title: '斗破苍穹 - 全本完结免费看',
    subtitle: '三年之约，热血逆袭，经典国漫巅峰之作',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20fantasy%20battle%20scene%20with%20a%20young%20warrior%20summoning%20flames%2C%20ancient%20Chinese%20fantasy%20landscape%20with%20mountains%20and%20clouds%2C%20epic%20cinematic%20lighting%2C%20dramatic%20orange%20and%20gold%20tones%2C%20anime%20art%20style%2C%20horizontal%20banner%20composition&width=1920&height=600&seq=banner-hero-01&orientation=landscape',
    color: 'from-amber-900/80 via-amber-800/60 to-black/40',
  },
  {
    id: 2,
    comicId: 8,
    title: '海贼王 - 连载中 每周更新',
    subtitle: '梦想不会终结！伟大航路持续冒险中',
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20pirate%20adventure%20scene%20with%20a%20pirate%20ship%20sailing%20on%20rough%20seas%20under%20dramatic%20sky%2C%20sunset%20colors%2C%20crew%20silhouettes%2C%20cinematic%20composition%2C%20anime%20art%20style%2C%20horizontal%20banner%20layout&width=1920&height=600&seq=banner-hero-02&orientation=landscape',
    color: 'from-rose-900/80 via-red-800/60 to-black/40',
  },
  {
    id: 3,
    comicId: 3,
    title: '狐妖小红娘 - 9.7分神作',
    subtitle: '转世续缘，千年等待，感动亿万读者的催泪之作',
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20fantasy%20scene%20with%20cherry%20blossoms%20falling%2C%20a%20beautiful%20fox%20spirit%20in%20traditional%20Chinese%20dress%2C%20soft%20pink%20and%20golden%20lighting%2C%20dreamy%20atmosphere%2C%20ancient%20Chinese%20temple%20background%2C%20anime%20art%20style%2C%20horizontal%20banner&width=1920&height=600&seq=banner-hero-03&orientation=landscape',
    color: 'from-pink-900/80 via-rose-800/60 to-black/40',
  },
];